import { template as template_406cdee4df324b669343dbb83ee9c9be } from "@ember/template-compiler";
import { hash } from '@ember/helper';
import { modelDisplayName, caption } from 'eflex/helpers';
const JemTaskPushToScheduleDetails = template_406cdee4df324b669343dbb83ee9c9be(`
<div ...attributes>
  <div class="mt-2 {{@childStatus.taskStatusClass}}">
    {{#each @childStatus.scheduleProcessData as |scheduleDatum|}}
      <div class="schedule-datum">
        <div class="fs-4 fw-semibold text-gray-800">
          {{caption scheduleDatum.station.captions}}
        </div>
        <div class="detail-text-value fw-bold text-gray-900">
          {{scheduleDatum.scheduleTarget}}x {{modelDisplayName scheduleDatum.model}}
        </div>
      </div>
    {{/each}}
  </div>
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default template_406cdee4df324b669343dbb83ee9c9be(`
  {{yield
    (hash
      taskDetails=(component
        JemTaskPushToScheduleDetails
        childStatus=@childStatus
      )
    )
  }}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
